







import { Component, Watch } from "vue-property-decorator";
import PartnerList from "@share/catalog/components/list/PartnerList.vue";
import Partner from "@share/catalog/components/Partner.vue";
import AnalyticsMixin from "@mixins/AnalyticsMixin";
import catalogDefaults, { Catalog } from "../../types/catalogDefaults";
import { getTranslatedCatalogPageName } from "@service/helpers/tabTitlesHelper";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

@Component({
    name: 'PartnerView',
    components: { PartnerList, Partner}
})
export default class PartnerView extends AnalyticsMixin {
    lastSchemaId = "";

    activated() {
        this.sendScreenView('Partners catalog', null, this.schemaId);
        this.setPageTitle();
    }

    @Watch('$route.params.schemaId')
    watchRouteSchemaId(schemaId: string) {
        if(schemaId) {
            this.lastSchemaId = schemaId;
        }
    }

    @Watch("schemaId")
    watchSchemaId(schemaId: string) {
        if(this.$route.params.schemaId === schemaId) {
            this.setPageTitle();
        }
    }

    setPageTitle(title = getTranslatedCatalogPageName(this.schemaId, this.catalogs, this.lang)) {
        this.$store.dispatch("setPageTitle", title);
    }

    get id() {
        return this.$route.params.id && this.$route.name === RouteNamesEnum.partner ? this.$route.params.id : null;
    }

    get schemaId() {
        return this.$route.params.schemaId ?? this.lastSchemaId ?? 'Exhibition';
    }

    get isCatalogAllowed() {
        return this.catalogs.findIndex(element => element.schemaId === this.schemaId) !== -1;
    }

    get catalogs(): Catalog[] {
        return this.$store.getters['events/selectedEventViewParam']('catalog', null) || catalogDefaults;
    }

    get lang() {
        return this.$store.state.session?.language ?? 'en'
    }
 }
